import React from 'react';
import './BackgroundCanvas.css';

const BackgroundCanvas = ({
  background = { type: 'color', color: '#FFFFFF' },
  width,
  height,
  className = '',
  children,
  onBackgroundClick
}) => {
  const getBackgroundStyle = () => {
    switch (background.type) {
      case 'color':
        return { backgroundColor: background.color };
      case 'gradient':
        return { background: background.gradient };
      case 'image':
        return {
          backgroundImage: `url(${background.imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        };
      case 'preset':
        return background.preset?.style || { backgroundColor: '#FFFFFF' };
      default:
        return { backgroundColor: '#FFFFFF' }; // Default beige
    }
  };

  const handleBackgroundClick = (e) => {
    // Only trigger if clicking directly on background (not on children)
    if (e.target === e.currentTarget && onBackgroundClick) {
      onBackgroundClick(e);
    }
  };

  return (
    <div
      className={`background-canvas ${className}`}
      style={{
        width: width || '100%',
        height: height || '100%',
        position: 'relative',
        ...getBackgroundStyle()
      }}
      onClick={handleBackgroundClick}
    >
      {children}
    </div>
  );
};

export default BackgroundCanvas;